import SubmissionConst from '@/submission_approval/ConstList'

/**
 * 承認待ち・承認済みで［保存］が押せない理由（2026-09-26）。
 *
 * 勤務表・業務報告・経費精算・通勤費精算は、読み込んだ月が承認待ち・承認済み
 * だと［保存］を押せなくし、その理由を画面の上（errors）に出す。ところが
 * ［保存］は表の下にあり、押せない理由がボタンのそばに無かった。
 *
 * 上に出している文と同じ文を［保存］のそばにも出すため、errors の中から
 * その理由だけを取り出す。**判定を2か所に書かない**（上に出す条件と、そばに
 * 出す条件がずれると、片方だけが出る）。
 *
 * @param locked 承認状態で押せなくしているか（画面の statusBtn）
 * @param errors 画面の上に出している文の並び
 * @returns 押せない理由。押せなくしていなければ空文字
 */
export function submissionLockReason (locked, errors) {
  if (!locked || !Array.isArray(errors)) return ''
  const reasons = [
    SubmissionConst.ERROR_UPDATE_MESSAGE_PENDING,
    SubmissionConst.ERROR_UPDATE_MESSAGE_APPROVAL
  ]
  return errors.find(one => reasons.includes(one)) || ''
}
